// extracted by mini-css-extract-plugin
var _1 = "Tklu0vm_aGZNJjxhOygn";
var _2 = "IokBf842TXMB2ypnvd3h";
var _3 = "yvAxmX79JyHqac9TPk7J";
var _4 = "s7ncLhV7LfaMQS99swGY";
export { _1 as "text", _2 as "textAlignCenter", _3 as "textWithMarginBottom", _4 as "textWithMarginTop" }
